module.exports = __webpack_public_path__ + "static/img/copyright1.c8876458.png";